<template lang="pug">
.add-text(
	:tabindex='lastTabIndex'
	:class='{ "open" : open }'
	@keydown.enter='openItem'
)

	.display-text.highlight-text(
		v-if='!open'
		@click='openItem'
	)
		.upload-icon.highlight-background(:class='{ "outline-circle" : !options.solidCircle }')
			.icon-plus.highlight-background
		p.label {{ options.title || "Add Text" }}

	.item-container(v-else)

		.item-wrapper(@dblclick='open = !open')

			p.label.highlight-text {{ options.label || options.title || "Add Text" }}
			input(
				:placeholder='options.placeholder || "type here"'
				v-model='localValue'
				ref='textInput'
				@keydown.enter='addItem'
			)

		.button.add.highlight-background(@click='addItem' v-if='!options.singleComment') Add

	.items
		.item( v-for='( item, index ) in items' )

			p {{ item }}
			.icon-close(@click='deleteItem( index )')

</template>

<script>
import TextInput from '@/components/form-inputs/TextInput';

export default {
	name : 'add-text',

	props : {

		options : {
			type : Object,
		},

		lastTabIndex : {
			type : Number,
		},

		value : {
			type : String,
		},

		errors : {
			type : Object,
		},

		data : {
			type : Object,
		},

		form : {
			type : Object,
		},

		formValue : {
			type : Object,
		},

		field : {
			type : Object,
		},

	},

	data : () => ( {
		open       : false,
		localValue : '',
		items      : [],
	} ),

	watch : {

		localValue( val ) {

			const isLetterOrNumber = a => /[a-zA-Z0-9]+/.test( a );

			if ( this.options.singleComment && isLetterOrNumber( val ) ) {
				this.$emit( 'input', val );
			}

		},

		value : {
			immediate : true,
			handler( val ) {
				if ( this.localValue !== val ) {
					this.localValue = val;
					this.open       = true;
				}
			}
		}

	},

	methods : {

		openItem() {

			this.open = true;

			// we have to wait for the container that holds
			// the input element to load before we are able
			// to select the input element, because of this,
			// we'll use vue's nextTick
			this.$nextTick( () => {
				this.$refs.textInput.focus();
			} );

		},

		addItem() {

			if ( this.localValue === '' || !this.localValue ) {
				return;
			}

			if ( this.options.singleComment ) {
				this.$emit( 'input', this.localValue );
				return;
			}

			this.items.push( this.localValue );

			this.localValue = '';

			this.$emit( 'input', this.items );

		},

		deleteItem( index ) {
			this.items.splice( index, 1 );
		},

	},

	components : {
		TextInput,
	}
};
</script>

<style lang="scss">

@keyframes slideDown {
	from {
		transform: translate( 0px, -10px );
		opacity: 0;
	}

	to {
		transform: translate( 0, 0 );
		opacity: 1;
	}
}

.add-text {
	width: 100%;

	// slide down animation is done here
	&.open {

		.item-container {
			animation: slideDown .2s 1 forwards;
		}
	}

	.display-text {
		width: 100%;
		text-align: center;
		color: $color-primary;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
		// the reason why we use margin instead of using padding on the
		// .add-item is because now if users click on the edge of the
		// box it'll still click this element rather than the parent
		// element receive the click event
		margin: 8px 0;

		.upload-icon {
			position: relative;
			height: 13px;
			width: 13px;
			overflow: visible;
			margin-right: 14px;
			padding: 12px;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;

			&.outline-circle {
				border: 2px solid;
				background: transparent!important;

				.icon-plus {

					&::before, &::after {
						background: inherit;
					}
				}
			}

			.icon-plus {

				&::before, &::after {
					content: '';
					position: absolute;
					top: 50%;
					left: 50%;
					height: 2px;
					width: 13px;
					background: white;
					border-radius: 2px;
				}

				&::before {
					transform: translate( -50%, -50%);
				}

				&::after {
					left: 50%;
					transform: translate(-51%, -50%) rotate(90deg);
				}
			}
		}

		p {
			color: inherit;
		}
	}

	.item-container {
		display: flex;
		flex-flow: row nowrap;
		justify-content: space-between;
		align-items: center;
		background: white;
		border-radius: 15px;
		box-shadow: 0px 4px 24px rgba(40, 54, 63, 0.2);
		padding: 5px 5px 5px 15px;
		min-height: 55px;

		.item-wrapper {
			display: flex;
			flex-flow: row nowrap;
			justify-content: flex-start;
			align-items: center;
			width: 100%;

			p.label {
				padding-right: 5px;
				font-weight: 600;
			}

			input {
				flex: 1 1 0;
				padding-right: 10px;
			}
		}

		.submit {
			background: $color-primary;
		}
	}

	.items {
		display: flex;
		flex-flow: column;
		padding-left: 15px;
		margin-top: 20px;
		width: 100%;

		.item {
			color: $input-color;
			display: flex;
			flex-flow: row nowrap;
			justify-content: space-between;
			align-items: center;
			max-width: 100%;

			p {
				text-overflow: ellipsis;
				max-width: 95%;
				overflow: hidden;
				white-space: nowrap;
			}
		}
	}
}

</style>
